import { useEffect, useRef } from 'react';
import { useTheme } from './ThemeProvider';

/**
 * Applies the logged-in user's saved ui_theme from the server on login / session refresh.
 * localStorage remains a fallback for the public login page before auth.
 */
export function UserThemeSync({ user }) {
  const { setTheme } = useTheme();
  const lastAppliedKey = useRef(null);

  useEffect(() => {
    if (!user?.id) {
      lastAppliedKey.current = null;
      return;
    }
    const saved = user.ui_theme;
    if (saved !== 'light' && saved !== 'dark') {
      return;
    }
    const key = `${user.id}:${saved}`;
    if (lastAppliedKey.current === key) {
      return;
    }
    lastAppliedKey.current = key;
    setTheme(saved);
  }, [user?.id, user?.ui_theme, setTheme]);

  return null;
}
